import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PASS_THROUGH } from '@attain-apps/transformers'
import type * as schema from '@attain-apps-be/schema'

export const EMPLOYEE_FILTERS = graphql.transformers.IN.object<
  ents.extra.space.Employee.Filter,
  schema.Inputs.SpaceEmployeeFilter
>(
  {
    jobTitleId: PASS_THROUGH,
    name: PASS_THROUGH,
    orgFilter: graphql.transformers.IN.object<
      ents.extra.space.Employee.Filter.OrgFilter,
      schema.Inputs.SpaceEmployeeOrgFilter
    >({
      entityId: PASS_THROUGH,
      recordIds: graphql.transformers.IN.list(PASS_THROUGH),
    }),
    search: PASS_THROUGH,
    isOccupant: PASS_THROUGH,
    isSponsored: PASS_THROUGH,
  },
  { onMissing: 'omit', onNullish: null },
)
